import React from 'react';
import { css } from 'styled-components';
import { ErrorField } from '../../../../ui/Input/ErrorField';

interface FormErrorFieldProps {
  field: string;
  cypress: string;
  withPadding?: boolean;
}

export const errorStyles = (withPadding: boolean) => css`
  margin-top: 5px;
  ${withPadding &&
  css`
    padding-left: 15px;
  `}
`;

export const FormErrorField: React.FC<FormErrorFieldProps> = ({
  field,
  cypress,
  withPadding = true
}) => {
  const formatError = (error: string) =>
    error.toLowerCase().replace('azn', 'AZN');

  return (
    <ErrorField
      field={field}
      cypress={cypress}
      divider={false}
      formatError={formatError}
      styles={errorStyles(withPadding)}
    />
  );
};
